import OverallSkillsBreakdownTable from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/OverallSkillsBreakdownTable/OverallSkillsBreakdownTable";

export default OverallSkillsBreakdownTable;
